var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OptionsField',{attrs:{"options":_vm.options,"validation-rules":{
    acceptPrivacy: _vm.validateAcceptPrivacy,
    acceptAll: _vm.validateAcceptAll,
  },"validation-messages":{
    acceptPrivacy: 'Bitte stimme der Datenschutzerklärung zu',
    acceptAll: 'Bitte stimme der Datenverarbeitung zu',
  },"validation":"acceptPrivacy","name":"consent","multiple":"","spaceless":"","centered":""}})}
var staticRenderFns = []

export { render, staticRenderFns }